export class CreateEmployee {
    id: number|undefined;
    bankId : string;
    departementId : string;
    matricule : string;
    initiale : string;
    poste : string;
    lastname : string;
    firstname : string;
    mobilePhone : string;
    businessEmail : string;
    businessPhone : string;
    username : string;
    password : string;
    photo : string;
    photoContentType : string;
    codeAgent: string;
  }